var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mBtnIndex",
    class: _vm.noStyle && 'noStyle',
    style: {
      '--background': _vm.background,
      '--borderRadius': _vm.borderRadius,
      '--arcBackground': _vm.arcBackground,
      '--fontSize': _vm.remTran(_vm.fontSize) + 'rem'
    },
    on: {
      "click": _vm.confirmFn
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.text))]), _c('img', {
    attrs: {
      "src": _vm.src,
      "alt": ""
    }
  }), _vm._m(0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "arc-wrapper"
  }, [_c('div', {
    staticClass: "arc"
  })]);
}];
export { render, staticRenderFns };